(function ($) {
  const postList = document.querySelectorAll(".fmp-archive__posts");
  const postCards = document.querySelectorAll(".fmp-post-card");

  if (postList) {
    const postContentHeight = function () {
      for (const postCard of postCards) {
        let clientHeight = postCard.children[0].clientHeight;
        postCard.children[1].style.height =
          "calc(100% - " + clientHeight + "px)";
      }
    };
    $(window).on("load resize", function () {
      postContentHeight();
    });
  }
})(jQuery);
